import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'orderStatusStyle',
  standalone: true
})
export class OrderStatusStylePipe implements PipeTransform {

  transform(status: string): { [key: string]: boolean } {
    if (!status) {
      return {};
    }

    switch (status.toUpperCase()) {
      case 'PENDING':
        return { 'bg-yellow-500/20': true, 'text-yellow-300': true, 'border': true, 'border-yellow-500/30': true };
      case 'CONFIRMED':
      case 'PAID':
        return { 'bg-green-500/20': true, 'text-green-300': true, 'border': true, 'border-green-500/30': true };
      case 'CANCELED':
        return { 'bg-red-500/20': true, 'text-red-300': true, 'border': true, 'border-red-500/30': true };
      case 'PAYMENT_INITIATED':
        return { 'bg-blue-500/20': true, 'text-blue-300': true, 'border': true, 'border-blue-500/30': true };
      case 'PAYMENT_FAILED':
        return { 'bg-red-600/20': true, 'text-red-300': true, 'border': true, 'border-red-600/30': true };
      default:
        return { 'bg-gray-500/20': true, 'text-gray-300': true, 'border': true, 'border-gray-500/30': true };
    }
  }
}
